import { Button } from "@devhop/ui";
import { DownloadIcon, PlusIcon } from "lucide-react";

export function StudentsToolbar({
  canManage,
  onCreate,
  onExportCsv,
  exporting,
}: {
  canManage: boolean;
  onCreate: () => void;
  onExportCsv: () => void;
  exporting?: boolean;
}) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
      <div>
        <h1 className="font-bold text-2xl tracking-tight">ນັກຮຽນ</h1>
        <p className="text-muted-foreground">ຈັດການຂໍ້ມູນນັກຮຽນ</p>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <Button
          type="button"
          variant="outline"
          disabled={exporting}
          onClick={onExportCsv}
        >
          <DownloadIcon className="size-4" />
          {exporting ? "ກຳລັງສົ່ງອອກ..." : "ສົ່ງອອກ CSV"}
        </Button>
        {canManage && (
          <Button onClick={onCreate}>
            <PlusIcon className="size-4" />
            ສ້າງນັກຮຽນ
          </Button>
        )}
      </div>
    </div>
  );
}
